import { BookingTimelineStrategy } from './booking-timeline-strategy';

export class DefaultBookingTimelineStrategy implements BookingTimelineStrategy {
  static id = 'DefaultBookingTimelineStrategy';

  get useInlineTimer(): boolean {
    return true;
  }
}
